module.exports = __webpack_public_path__ + "img/62.896c5a26.svg";